import {
  SnippetElement,
  defineElement,
  param,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/util-popover/util-popover.ts
var UtilPopover = class extends SnippetElement {
  constructor() {
    super();
    this.isOpen = false;
    this.init();
  }
  init() {
    return __async(this, null, function* () {
      if (this.key != null && UtilPopover.states[this.key]) {
        this.classList.add("!duration-0");
        yield this.open();
        yield wait(10);
        this.classList.remove("!duration-0");
      }
    });
  }
  getTransitionDuration() {
    var _a;
    return parseFloat((_a = getComputedStyle(this).transitionDuration) != null ? _a : 0) * 1e3;
  }
  toggle() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        yield this.close();
      } else {
        yield this.open();
      }
    });
  }
  saveState() {
    if (this.key != null) {
      UtilPopover.states[this.key] = this.isOpen;
    }
  }
  open() {
    return __async(this, null, function* () {
      this.isOpen = true;
      this.classList.remove("hidden");
      yield wait(1);
      this.classList.remove("opacity-0", "translate-y-1");
      this.classList.add("opacity-100", "translate-y-0");
    });
  }
  close() {
    return __async(this, null, function* () {
      this.isOpen = false;
      this.classList.remove("opacity-100", "translate-y-0");
      this.classList.add("opacity-0", "translate-y-1");
      yield wait(this.getTransitionDuration() + 1);
      if (!this.isOpen) {
        this.classList.add("hidden");
      } else {
        this.open();
      }
    });
  }
  disconnectedCallback() {
    this.remove();
  }
};
UtilPopover.states = {};
__decorateClass([
  param("key")
], UtilPopover.prototype, "key", 2);
UtilPopover = __decorateClass([
  defineElement("util-popover")
], UtilPopover);
export {
  UtilPopover
};
